import { render, staticRenderFns } from "./SyllabusEffects.vue?vue&type=template&id=994b77ce&"
import script from "./SyllabusEffects.vue?vue&type=script&lang=js&"
export * from "./SyllabusEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports